/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import * as actionTypes from './actionTypes';

const initialState = {
  planType: [],
  errorMsgCmsMiss: [],
  rebateProgram: [],
  searchScreenData: {},
  quarter: '',
  checkedValue: { invoiced: 0, nonInvoiced: 0 },
  cmsMismatchDetail: [],
  cmsMismatchDetailData: {},
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: action.payload };
    case actionTypes.GET_CHECKED_VALUE:
      return { ...state, checkedValue: action.payload };
    case actionTypes.GET_ERROR_MSG_CMS_MISMATCH:
      return { ...state, errorMsgCmsMiss: action.payload };
    case actionTypes.GET_REBATE_PROGRAM:
      return { ...state, rebateProgram: action.payload };
    case actionTypes.SEARCH_SCREEN_TAB_CMS_MISMATCH:
      return { ...state, searchScreenData: action.searchScreen };
    case actionTypes.GET_CMS_MISMATCH_DETAIL_TAB_DATA:
      return { ...state, cmsMismatchDetailData: action.detailScreen };
    case actionTypes.GET_QUARTER_VALUE:
      return { ...state, quarter: action.payload };
    case actionTypes.GET_CMS_MISMATCH_DETAIL:
      const cmsMismatchDetailsObj = action?.payload;
      if (cmsMismatchDetailsObj) {
        if (
          cmsMismatchDetailsObj?.cmsMisMatchDetailResponseVO &&
          cmsMismatchDetailsObj?.cmsMisMatchDetailResponseVO?.length > 0
        ) {
          cmsMismatchDetailsObj.cmsMisMatchDetailResponseVO.forEach(
            (element) => {
              element.numOfUnits = parseFloat(element?.numOfUnits).toFixed(3);
              element.reimbursementAmt = `$ ${parseFloat(
                element?.reimbursementAmt
              ).toFixed(2)}`;
              if (element.minClaimDt !== null && element.minClaimDt !== '')
                element.minClaimDt = moment(element.minClaimDt).format(
                  'MM/DD/yyyy'
                );
            }
          );
        }
      }
      return { ...state, cmsMismatchDetail: cmsMismatchDetailsObj };
    default:
      return state;
  }
};

export default reducer;
